import { useDispatch } from 'react-redux';
import Button from 'components/Button';
import ItemDetails from 'components/ItemDetails';
import { setSelectedBooking } from 'reducers/ui/uiSlice';
import { BUTTON_TYPE_LINK } from 'shared/constants/common';
import { ROUTES_SELF_SERVICE } from 'shared/constants/selfServiceRoutes';
import { displayAmount, displayDate } from 'shared/helpers/common';
import {
  getQuoteBookingComponentOverview,
  generateTitle,
} from 'shared/helpers/quoteBooking';

export default function BundlesItem({ booking = {} }) {
  const dispatch = useDispatch();

  const {
    id,
    reference,
    currency,
    currentPrice,
    price,
    outbound,
    destination,
    destinations,
    accommodation,
    cruises,
    tours,
    flights,
    due,
    balanceDueDate,
  } = booking;

  const {
    name: componentName,
    dateToDisplay,
    componentType,
  } = getQuoteBookingComponentOverview(booking);

  const selectBooking = () => {
    dispatch(setSelectedBooking(booking));
  };

  return (
    <div className="rounded-[10px] mt-[40px] bg-white flex flex-col lg:flex-row lg:justify-between">
      <ItemDetails
        className="p-4 w-full"
        title={generateTitle(
          outbound,
          destination,
          destinations,
          accommodation,
          cruises,
          tours,
          flights,
          true,
          true,
        )}
        componentType={componentType}
        componentName={componentName}
        date={dateToDisplay}
        totalPrice={displayAmount(currentPrice || price, currency)}
        due={displayAmount(due, currency)}
        balanceDueDate={displayDate(balanceDueDate, '-', undefined, true)}
        reference={reference}
        isLoyaltyBooking
        isHorizontal
      />
      <div className="flex flex-col border-t lg:border-l lg:border-t-0 lg:w-[300px] lg:justify-end">
        <Button
          label="View bundle"
          className="m-3"
          type={BUTTON_TYPE_LINK}
          onClick={selectBooking}
          url={`${ROUTES_SELF_SERVICE.BOOKINGS}/${id || reference}`}
        />
      </div>
    </div>
  );
}
